import type { KnownCrawlerFolder } from './email-crawler-folders';

export interface EmailSchedulerBootstrapContext {
  canonicalPrefix?: string;
  sourceKey?: string;
}

export function buildPrefixStatusUrl(apiBaseUrl: string, folder: KnownCrawlerFolder): string {
  return `${apiBaseUrl}/api/email-scheduler/status?prefix=${encodeURIComponent(folder.prefix)}`;
}

export function buildBootstrapRequest(folder: KnownCrawlerFolder): RequestInit {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ prefix: folder.prefix }),
  };
}

export function matchesBootstrapContext(
  response: EmailSchedulerBootstrapContext,
  folder: KnownCrawlerFolder,
): boolean {
  return response.canonicalPrefix === folder.prefix && response.sourceKey === folder.sourceKey;
}
